<template>
    <q-page padding>
        <div class="q-display-1 q-mb-md text-secondary">
            <q-icon name="fas fa-cloud-upload-alt" class="q-mb-sm" /> {{ $t('import') }}
        </div>
            <p class="q-mb-none text-weight-light">
                {{$t('store_import_template_start')}}
                <span class="text-weight-medium cursor-pointer" @click="getTemplateUser()"> import_company_layout.xlsx</span>
			    {{$t('store_import_template_end')}}
            </p>
        <br>
        <uploader content_type="xlsx" @fileUploaded="imageDesktopUploaded" :multiple="false" :cropper="false" :error="$v.file.$error" @input="$v.file.$touch" />
        <div class="row gutter-sm justify-end q-mt-ld q-mb-xl">
            <div class="col-xs-12 col-sm-3">
                <q-btn color="secondary" class="full-width" :label="$t('upload')" icon="fas fa-upload" @click="validateLines()" />
            </div>
        </div>
        <h4 v-if="branches.length > 0" class="q-my-md">{{$t('all_store_errors')}}</h4>
        <q-table
            :data="branches"
            :columns="columns"
            :filter="filter"
            row-key="line"
            v-if="branches.length > 0"
        >
            <q-tr slot="body" slot-scope="props" :props="props">
                <q-td key="line" :props="props">{{ props.row.line }}</q-td>
                <q-td key="name" :props="props">{{ props.row.name }}</q-td>
                <q-td key="status_message" :props="props">{{ props.row.status_message.map(e => $t(e)).join(', ') }}</q-td>
                <q-td key="error_count" :props="props" auto-width>
                    <q-chip small :icon="getIconStatus(props.row.error_count)" :color="getColorStatus(props.row.error_count)" class="full-width">
                        {{ $t(getStatus(props.row.error_count)) }}
                    </q-chip>
                </q-td>
            </q-tr>
        </q-table>

        <h4  v-if="companies.length > 0" class="q-my-md">{{$t('all_headquarters_errors')}}</h4>
        <q-table
            :data="companies"
            :columns="columns"
            :filter="filter"
            row-key="line"
            v-if="companies.length > 0"
        >
            <q-tr slot="body" slot-scope="props" :props="props">
                <q-td key="line" :props="props">{{ props.row.line }}</q-td>
                <q-td key="name" :props="props">{{ props.row.name }}</q-td>
                <q-td key="status_message" :props="props">{{ props.row.status_message.map(e => $t(e)).join(', ') }}</q-td>
                <q-td key="error_count" :props="props" auto-width>
                    <q-chip small :icon="getIconStatus(props.row.error_count)" :color="getColorStatus(props.row.error_count)" class="full-width">
                        {{ $t(getStatus(props.row.error_count)) }}
                    </q-chip>
                </q-td>
            </q-tr>
        </q-table>

        <div v-if="button">
            <div class="q-pa-md bg-green-2">
                <p class="q-mb-none">{{$t('all_headquarters')}} {{ qtd_companies }}</p>
                <p class="q-mb-none">{{$t('all_store')}}  {{ qtd_branches }}</p>
            </div>
            <div class="row gutter-sm justify-end q-mt-lg">
                <div class="col-xs-12 col-sm-3">
                    <q-btn color="negative" class="full-width" :label="$t('cancel')" icon="far fa-trash-alt" @click="cancel()" />
                </div>

                <div class="col-xs-12 col-sm-3">
                    <q-btn color="secondary" class="full-width" :label="$t('save')" icon="far fa-save" @click="saveData()" />
                </div>
            </div>
        </div>
        <q-dialog v-model="show_message" @ok="hideError()" :cancel="false">
            <span slot="title">Atenção</span>
            <span slot="message">Aguarde, a importação de redes e lojas está sendo processada. Você será notificado(a) no final do processo</span>
        </q-dialog>
    </q-page>
</template>

<script>
import Uploader from 'components/Uploader'
import { mapGetters } from 'vuex'
import { required, requiredIf, url } from 'vuelidate/lib/validators'
export default {
    i18nOptions: { namespaces: [ "custom", "common", "training", "admin", "courses"] },
     components: {
        'uploader': Uploader,
    },
    data() {
		return{
            file: "",
            filter: "",
            button: false,
            companies: [],
            branches: [],
            qtd_companies:[],
            qtd_branches:[],
            companies_save:'',
            show_message: false,
            columns: [
                { name: 'line', required: true, label: 'Linha', align: 'left', field: 'line', sortable: true },
                { name: 'name', label: 'Nome', align: 'left',field: 'name', sortable: true },
                { name: 'status_message', label: 'Mensagem de erro', align: 'left',field: 'status_message', sortable: true },
                { name: 'error_count', label: 'Status',align: 'left', field: 'error_count', sortable: true },
            ]
		}
    },

    computed: {
		...mapGetters({
            access_token: 'common/access_token',
            id_user:'common/id'
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },
    },

  	methods:{
		forceFileDownload(response){
			const link = document.createElement('a')
			link.href = response
			document.body.appendChild(link)
			link.click()
		},

		getTemplateUser(){
            this.$q.loading.show({
                message: "Aguarde, gerando planilha"
            })
			this.$axios.get(`/admin_companies_import/import_company_new/get_import_company_template/`, this.getHeader)
			.then(response => {
				this.forceFileDownload(response.data.path_url)
			})
			.catch(e => {
				console.log(e)
            })
            .finally(() =>{
                this.$q.loading.hide()
            })
        },

        imageDesktopUploaded(url) {
            this.file = url
        },

        validateLines() {
            this.$v.$touch()
            if (!this.$v.$error) {
                this.$q.loading.show()

                let fd = new FormData()
                fd.append('file_url', this.file)

                this.$axios.post(`/admin_companies_import/import_company_new/get_validate_template_lines/`, fd, this.getHeader)
                .then(response => {
                    this.companies_save = response.data
                    this.button = false
                    this.companies = response.data.companies.filter(companie => {
                        if(companie.error_count > 0) {
                            return {
                                'line':companie.line,
                                'name': companie.name,
                                'status_message':companie.status_message,
                                'error_count':companie.error_count,
                            }
                        }
                    })

                    this.branches = response.data.branches.filter(branch => {
                        if(branch.error_count > 0) {
                            return {
                                'line':branch.line,
                                'name': branch.name,
                                'status_message':branch.status_message,
                                'error_count': branch.error_count
                            }
                        }
                    })

                    if(this.companies.length == 0 && this.branches.length == 0){
                        this.button = true
                        this.qtd_companies = response.data.companies.length
                        this.qtd_branches = response.data.branches.length
                    }

                    this.$q.loading.hide()
                })
                .catch(e => {
                    this.$q.loading.hide()
                    console.log(e)
                })
            }
        },

        saveData(){
            this.$q.loading.show()
            this.$axios.post(`/admin_companies_import/import_company_new/import_company_template_data/`, this.companies_save, this.getHeader)
            .then(response => {
                this.show_message = true
                this.$q.loading.hide()
                this.cancel()
                // this.$q.notify({
                //     //message: this.$t('badge_add_success'),
                //     message: 'Aguarde, a importação de redes e lojas está sendo processada',
                //     type: 'positive',
                //     icon: 'far fa-save'
                // })
            })
            .catch(e => {
                this.$q.loading.hide()
                console.log(e)
            })
        },

        cancel(){
            this.filter = ""
            this.button = false
            this.companies = []
            this.branches = []
            this.companies_save =''
        },

        getStatus(status) {
            // if (status >= 0) return 'aproved'
            // else if (status == 2) return 'error'
            return status >= 0 ? 'error' : 'aproved'
        },

        getIconStatus(status) {
            return status >= 0 ? 'fas fa-ban' : 'fas fa-check'
            // if (status == 1) return 'fas fa-check'
            // else if (status == 2) return 'fas fa-ban'
        },

        getColorStatus(status) {
            return status >= 0 ? 'negative' : 'positive'
            // if (status == 1) return 'positive'
            // else if (status == 2) return 'negative'
        },
    },
    validations() {
        return {
            file: { required },
        }
    }
}
</script>

<style scoped>
.alert-template {
    border-left: 5px solid #7a927a;
    border-right: 5px solid #7a927a;
}
</style>